import './Loader.css';
import { FaFilePdf, FaFileAlt, FaFileExcel } from 'react-icons/fa';

interface LoaderProps {
  label?: string
}

const Loader: React.FC<LoaderProps> = ({
  label
}) => {
  return (
    <div id="loader">
      {/* piste de course */}
      <div className="race-track">
        {/* PDF (le plus rapide) */}
        <div className="racer r1">
          <div className="icon-body">
            <div className="thruster">
              <span></span><span></span><span></span><span></span>
            </div>
            <FaFilePdf className="loader-icon" />
          </div>
        </div>

        {/* TXT */}
        <div className="racer r2">
          <div className="icon-body">
            <div className="thruster">
              <span></span><span></span><span></span><span></span>
            </div>
            <FaFileAlt className="loader-icon" />
          </div>
        </div>

        {/* XLSX */}
        <div className="racer r3">
          <div className="icon-body">
            <div className="thruster">
              <span></span><span></span><span></span><span></span>
            </div>
            <FaFileExcel className="loader-icon" />
          </div>
        </div>
      </div>

      {/* lignes rapides d’arrière-plan */}
      <div className="longfazers">
        <span></span><span></span><span></span><span></span>
      </div>

      <h1>{ label ?? "Chargement de vos fichiers" }</h1>
    </div>
  );
};

export default Loader;
